import { SliceCaseReducers } from '@reduxjs/toolkit'
import {
  BankingProductMovementsApiResponse,
  BankingProductMovementsParams,
} from '@repo/accounts-types'
import { ApiResponse, createOperationSlice, GenericOperationState } from '@repo/core'

const initialState: GenericOperationState<ApiResponse<BankingProductMovementsApiResponse> | null> =
  {
    payload: null,
    meta: { fetchState: 'initial' },
    error: false,
  }

export const {
  actions: bankingProductMovementsDataActions,
  reducer: bankingProductMovementsDataReducer,
} = createOperationSlice<
  ApiResponse<BankingProductMovementsApiResponse> | null,
  SliceCaseReducers<GenericOperationState<ApiResponse<BankingProductMovementsApiResponse> | null>>,
  BankingProductMovementsParams
>({
  name: '@accounts/master/list/bankingProductMovements',
  initialState,
  reducers: {},
})
